import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

import {
  type IFailureCauseCategories,
  type IFailureCauseCategoriesKeys,
} from '../model/failureCauseCategories';

const failureCauseCategoriesListKey = (
  keys: IFailureCauseCategoriesKeys,
): [string, Array<number>, ITableSorting, string, Date, Date] => [
  'failureCauseCategories',
  keys.locationIds,
  keys.sorting,
  keys.statusType,
  keys.dateFrom,
  keys.dateTo,
];

const failureCauseCategoriesListFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof failureCauseCategoriesListKey>>) => {
  const orderBy = queryKey[2].id ? queryKey[2].id : undefined;
  const direction = !queryKey[2].id ? undefined : queryKey[2].desc ? 'desc' : 'asc';

  const params = {
    location_ids: queryKey[1],
    sort: {
      field: orderBy,
      direction: direction,
    },
    status_type: queryKey[3] === 'all' ? undefined : queryKey[3],
    date_from: queryKey[4],
    date_to: queryKey[5],
  };

  return apiClient.get<{ data: IFailureCauseCategories[] }>(
    `${APP_API_URL_V2}fsd/action-item/failure-cause-categories`,
    {
      params,
      paramsSerializer: {
        serialize: (params) => qs.stringify(params),
      },
    },
  );
};

const failureCauseCategoriesListSelect = ({ data }: AxiosResponse<{ data: IFailureCauseCategories[] }>) => {
  if (!data.data) {
    return [];
  }
  return data.data;
};

export const useFailureCauseCategoriesListQuery = (keys: IFailureCauseCategoriesKeys) => {
  return useQuery({
    queryKey: failureCauseCategoriesListKey(keys),
    queryFn: failureCauseCategoriesListFn,
    select: failureCauseCategoriesListSelect,
    enabled: keys.enabled,
    keepPreviousData: true,
  });
};
